import {connect} from 'react-redux'
import EventsGroup from '../components/events_group'

const mapStateToProps = (state, ownProps) => {
  const { roundId, roundList } = state.leaderboardV2;

  const currentRound = roundList.find(r => r.id === roundId);

  return {
    snapshotsId: Object.fromEntries(
      ownProps.events.map(event => {
        const snapshotId = event.snapshots?.find(s => s.index === currentRound?.index)?.id ?? null;
        return [event.id, snapshotId];
      })
    )
  };
}

export default connect(mapStateToProps)(EventsGroup)
